import styled from 'styled-components'
import { StyledButton as Button } from '../../styles'
import { Theme } from '@pga/pga-component-library'

export const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 84px 20px;
  width: 100%;
  background-color: ${Theme.colors.white};
`

export const StyledCtaContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  padding: 28px;
  height: 350px;
  max-width: 356px;
  border: 1px solid ${Theme.colors.pearlGrey};
  transition: 0.1s ease-out;
  :hover {
    box-shadow: ${Theme.colors.bgGrey} 0px 10px 10px 0px;
  }
  :last-child {
    margin-right: 0px;
  }
  @media screen and (max-width: 992px) {
    height: 420px;
  }
  @media (max-width: 768px) {
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 30px;
    :last-child {
      max-width: 100%;
    }
  }
`

export const StyledCtaTitle = styled.div`
  margin-bottom: 15px;
  font-family: ${props => props.theme.fonts.body};
  font-size: 20px;
  font-weight: bold;
  color: ${Theme.colors.primary};
`

export const StyledCtaInfo = styled.div`
  margin-bottom: 35px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: ${Theme.colors.primary};
  text-align: center;
`

export const StyledButton = styled(Button)`
  padding: 13px 15px;
  white-space: normal;
`

export const StyledLink = styled.a`
  width: 100%;
  :hover {
    text-decoration: none;
  }
`

export const IconWrapper = styled.div`
  margin-bottom: 21px;
`
